import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    error:
      'The message wasn’t sent. If the problem persists, please contact support@shine.fr',
    form: {
      articles: 'These articles may be of interest to you',
      category: 'Category',
      contactReason: 'Contact reason',
      question: 'Please describe your question here',
      selectCategory: 'Choose a category',
      selectContactReason: 'Choose a contact reason',
      selectSubCategory: 'Select a sub category',
      subCategory: 'Sub Category',
      submit: 'Send my message',
    },
    subtitle: 'Select a contact reason to help us respond to you better.',
    title: 'I have a question',
  },
  fr: {
    error:
      'Votre message n’a pas pu être envoyé. Si le problème persiste, merci de contacter support@shine.fr',
    form: {
      articles: 'Ces articles pourraient vous intéresser',
      category: 'Catégorie',
      contactReason: 'Motif de contact',
      question: 'Décrivez ici votre question',
      selectCategory: 'Choisissez une catégorie',
      selectContactReason: 'Choisissez un motif de contact',
      selectSubCategory: 'Choisissez une sous-catégorie',
      subCategory: 'Sous-Catégorie',
      submit: 'Envoyer mon message',
    },
    subtitle:
      'Sélectionnez un motif de contact pour nous aider à mieux vous répondre.',
    title: 'J’ai une question',
  },
} as const);

export default locales;
